import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopUpModel } from '../../utilidades.modelos.index';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-pop-up',
	templateUrl: './pop-up.component.html',
	styles: []
})
export class PopUpComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<PopUpComponent>,
		@Inject(MAT_DIALOG_DATA) public Datos: PopUpModel) { }

	ngOnInit() {
		if (environment.Debug) {
			console.log(this.Datos);
		}
	}

	CerrarPopUp() {
		this.dialogRef.close();
	}

	async SiClick() {
		if (this.Datos.SiClick) {
			await this.Datos.SiClick();
		}

		this.CerrarPopUp();
	}

	async NoClick() {
		if (this.Datos.NoClick) {
			await this.Datos.NoClick();
		}

		this.CerrarPopUp();
	}
}